<template>
  <div id="member-subscription-create">
    <v-card class="modern-header slide-up-animation" elevation="2">
      <v-card-title class="modern-card-title pa-0">
        <!-- Floating Bubbles Background -->
        <ul class="bg-bubbles">
          <li v-for="n in 10" :key="n"></li>
        </ul>
        <div class="header-left">
          <v-icon class="mr-4 flying-icon" size="48" color="#ffffff"
            >mdi-credit-card</v-icon
          >
          <div class="title-content">
            <h1 class="page-title">Member Subscription Payment</h1>
            <p class="page-subtitle">
              Manage payment transactions for the year
            </p>
          </div>
        </div>
        <v-spacer />
        <div class="header-actions">
          <v-btn
            @click.prevent="pageData"
            icon
            color="#ffffff"
            class="action-btn"
            v-tooltip="'Refresh Data'"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-card-text>
        <v-container class="notes modern-notes" v-if="NotesFlag">
          <v-icon class="mr-2" small color="#FF6B6B"
            >mdi-information-outline</v-icon
          >
          <span class="notes-title">Important Notes:</span>
          <ol class="notes-list">
            <li>
              <v-icon x-small class="mr-1">mdi-check-circle</v-icon> Regular
              subscription can be paid only once.
            </li>
            <li>
              <v-icon x-small class="mr-1">mdi-check-circle</v-icon> After
              paying regular subscription, choose additional subscription.
            </li>
            <li>
              <v-icon x-small class="mr-1">mdi-check-circle</v-icon> Late fee is
              optional but paying late fee is required to get voting rights.
            </li>
            <li>
              <v-icon x-small class="mr-1">mdi-check-circle</v-icon> After
              completing the payment, select your members for whom the payment
              was made.
            </li>
          </ol>
        </v-container>
        <br />
        <div class="d-flex justify-content-end mb-4">
          <div class="required-pill">
            <span class="required-star">*</span>
            <span class="required-text">Indicates required fields</span>
          </div>
        </div>
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <v-container v-if="StartupLoadingFlag">
          <v-row wrap>
            <v-col cols="12" md="4" v-for="n in 6" :key="n">
              <v-skeleton-loader
                v-bind="attrs"
                type="paragraph"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="!StartupLoadingFlag">
          <v-form ref="form2" v-model="valid1" lazy-validation>
            <v-card
              class="form-section form-section-org slide-up-animation delay-100"
              elevation="1"
            >
              <div class="card-bubbles-container">
                <div class="card-bubble" v-for="n in 5" :key="n"></div>
              </div>
              <v-card-title class="section-title">
                <v-icon class="section-icon-wrapper" color="#3A67B1"
                  >mdi-office-building</v-icon
                >
                Organization Details
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-6">
                <v-row wrap>
                  <v-col cols="12" md="3">
                    <label class="field-label"
                      ><span class="text-danger">*</span>Year</label
                    >
                    <v-autocomplete
                      @change="searchForm"
                      :reduce="(option) => option.value"
                      :items="JciYearCodeOptions"
                      :rules="JciYearCodeRules"
                      :loading="JciYearCodeOptionsLoading"
                      v-model="JciYearCode"
                      hint="Select Financial Year"
                      dense
                      clearable
                      required
                      outlined
                      rounded
                      prepend-inner-icon="mdi-calendar"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="3">
                    <label class="field-label"
                      ><span class="text-danger">*</span>LOM
                    </label>
                    <h4 class="info-text">{{ Member.LomName }}</h4>
                    <h5 class="info-subtext">{{ Member.ZoneName }}</h5>
                  </v-col>
                  <v-col cols="12" md="3">
                    <label class="field-label"
                      ><span class="text-danger">*</span>President Name</label
                    >
                    <h4 class="info-text">{{ Member.MemberName }}</h4>
                    <h5 class="info-subtext">{{ Member.MembershipId }}</h5>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    class="d-flex justify-center align-center"
                  >
                    <v-img
                      :src="Member.MemberImagePath"
                      :alt="Member.MemberName"
                      lazy-src="/no-image-available.png"
                      max-width="120"
                      max-height="120"
                      class="member-image float-animation"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card
              class="form-section form-section-location mt-6 slide-up-animation delay-200"
              elevation="1"
            >
              <div class="card-bubbles-container">
                <div class="card-bubble" v-for="n in 5" :key="n"></div>
              </div>
              <v-card-title class="section-title">
                <v-icon class="section-icon-wrapper" color="#c31432"
                  >mdi-map-marker-multiple</v-icon
                >
                Location & Contact Details
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-6">
                <v-row wrap>
                  <v-col cols="12" sm="6" md="3">
                    <h6 class="field-label">
                      <span class="text-danger">*</span> State Of LO
                    </h6>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :loading="StateCodeOptionsLoading"
                      :items="StateCodeOptions"
                      :rules="StateCodeRules"
                      v-model="StateCode"
                      required
                      outlined
                      dense
                      rounded
                      prepend-inner-icon="mdi-map"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <h6 class="field-label">
                      <span class="text-danger">*</span> District Of LO
                    </h6>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :loading="DistrictCodeOptionsLoading"
                      :items="DistrictCodeOptions"
                      :rules="DistrictCodeRules"
                      v-model="DistrictCode"
                      required
                      outlined
                      dense
                      rounded
                      prepend-inner-icon="mdi-city"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <h6 class="field-label">
                      <span class="text-danger">*</span> City Of LO
                    </h6>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :loading="CityCodeOptionsLoading"
                      :items="CityCodeOptions"
                      :rules="CityCodeRules"
                      v-model="CityCode"
                      dense
                      clearable
                      required
                      outlined
                      rounded
                      prepend-inner-icon="mdi-map-marker"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label class="field-label"
                      ><span class="text-danger">*</span>Mobile Number</label
                    >
                    <v-text-field
                      v-model="Member.PrimaryMobile"
                      :rules="MobileNoRules"
                      :counter="10"
                      v-mask="'##########'"
                      type="number"
                      hint="10 digit mobile number"
                      dense
                      outlined
                      rounded
                      prepend-inner-icon="mdi-phone"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label class="field-label"
                      ><span class="text-danger">*</span>Email Id</label
                    >
                    <v-text-field
                      v-model="Member.EmailId"
                      :rules="EmailIdRules"
                      type="email"
                      hint="example@email.com"
                      dense
                      outlined
                      rounded
                      prepend-inner-icon="mdi-email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label class="field-label">GST Number</label>
                    <v-select
                      :reduce="(option) => option.value"
                      :items="GstNumberFlagOptions"
                      :rules="GstNumberFlagRules"
                      v-model="GstNumberFlag"
                      required
                      outlined
                      dense
                      rounded
                      prepend-inner-icon="mdi-file-document"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" v-if="GstNumberFlag == 1">
                    <label class="field-label"
                      ><span class="text-danger">*</span>GST Number</label
                    >
                    <v-text-field
                      v-model="Member.LomGstNumber"
                      :rules="GstNumberRules"
                      outlined
                      dense
                      rounded
                      prepend-inner-icon="mdi-file-certificate"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-container class="py-0" v-if="SearchFlag">
              <v-skeleton-loader
                v-bind="attrs"
                type="table-tbody"
              ></v-skeleton-loader>
            </v-container>

            <v-card
              class="mt-6 slide-up-animation delay-300"
              elevation="1"
              v-if="!SearchFlag"
            >
              <div class="card-bubbles-container card-bubbles-tabs">
                <div class="card-bubble" v-for="n in 6" :key="n"></div>
              </div>
              <v-tabs
                v-model="tab"
                background-color="transparent"
                centered
                dark
                icons-and-text
                show-arrows
                class="modern-tabs custom-tabs-bg"
              >
                <v-tabs-slider class="slider-custom"></v-tabs-slider>

                <v-tab href="#tab-1" :disabled="TabDisable1" class="tab-item">
                  <v-icon class="mr-2">mdi-cash-multiple</v-icon>
                  Subscription
                </v-tab>

                <v-tab href="#tab-2" :disabled="TabDisable2" class="tab-item">
                  <v-icon class="mr-2">mdi-alert-circle</v-icon>
                  Late Fee
                </v-tab>

                <v-tab href="#tab-3" :disabled="TabDisable3" class="tab-item">
                  <v-icon class="mr-2">mdi-star</v-icon>
                  Senior Members
                </v-tab>

                <v-tab
                  href="#tab-4"
                  :disabled="TabDisable4"
                  :class="[
                    'tab-item',
                    BalancePayment && BalancePayment.length > 0
                      ? 'tab-has-records'
                      : '',
                  ]"
                  v-if="BalancePaymentFlag"
                >
                  <v-icon class="mr-2">mdi-wallet-outline</v-icon>
                  Balance
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab" class="tabs-content">
                <v-tab-item value="tab-1">
                  <v-card flat class="tab-card">
                    <v-card-text class="pt-6">
                      <v-row wrap>
                        <v-col align="center" cols="12" md="12">
                          <h3 class="tab-heading">
                            <v-icon class="mr-2" color="#8950FC"
                              >mdi-cash-multiple</v-icon
                            >
                            List of Regular Subscriptions
                          </h3>
                        </v-col>
                      </v-row>
                      <v-row wrap>
                        <v-col align="center" cols="12" md="12">
                          <v-data-table
                            class="modern-table"
                            disable-sort
                            disable-filtering
                            v-model="selected"
                            :loading="SearchFlag"
                            loading-text="Loading... Please wait"
                            :headers="tableColumns1"
                            :items="rows"
                            :items-per-page="50"
                            :search="search"
                            item-key="YearwiseContributionId"
                            :single-select="false"
                            :show-select="false"
                            :hide-default-footer="true"
                            :footer-props="{
                              'items-per-page-options': [10, 20, 30, 40, 50],
                            }"
                          >
                            <template v-slot:item.FineCheckBox="{ item }">
                              <v-checkbox
                                v-if="item.FineFlag"
                                v-model="item.FinePaidFlag"
                                :label="item.FineAmountTxt"
                                color="info"
                                :value="item.FinePaidFlag"
                                hide-details
                                v-on="calculateTotal()"
                              ></v-checkbox>
                            </template>
                            <template v-slot:item.Qty="{ item }">
                              <v-text-field
                                v-model="item.Qty"
                                v-on="calculateTotal()"
                                type="number"
                                min="0"
                                :rules="QtyRules"
                                outlined
                                dense
                                class="qty-input"
                              ></v-text-field>
                            </template>
                            <template v-slot:item.SubTotal="{ item }">
                              <div class="amount-text">
                                ₹ {{ getDecimalNumber(item.SubTotal, 2) }}
                              </div>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                      <v-row class="mt-6">
                        <v-col align="center" cols="12" md="12">
                          <h3 class="total-amount">
                            <v-icon small color="#8950FC" class="mr-2"
                              >mdi-calculator</v-icon
                            >
                            Total Amount :
                            <span class="amount-value"
                              >₹ {{ TotalAmount1 }}</span
                            >
                          </h3>
                          <v-checkbox
                            v-model="checkbox1"
                            :rules="checkboxRules1"
                            required
                            class="mt-4"
                          >
                            <template v-slot:label>
                              <div style="font-size: 14px">
                                I have read and accepted the
                                <a
                                  href="#"
                                  @click.prevent="openPage(6)"
                                  class="link-text"
                                  >terms and conditions</a
                                >.
                              </div>
                            </template>
                          </v-checkbox>
                          <v-btn
                            :disabled="!valid1"
                            @click.prevent="submitRegularSubscription"
                            :loading="SubmitFlag"
                            elevation="6"
                            rounded
                            large
                            class="submit-btn btn-gradient-success white--text"
                          >
                            <v-icon left>mdi-check-circle</v-icon>
                            Submit
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item value="tab-2">
                  <v-card flat class="tab-card">
                    <v-card-text class="pt-6">
                      <v-row wrap>
                        <v-col align="center" cols="12" md="12">
                          <h3 class="tab-heading">
                            <v-icon class="mr-2" color="#FF6B6B"
                              >mdi-alert-circle</v-icon
                            >
                            List of Late Fee Subscriptions
                          </h3>
                        </v-col>
                      </v-row>
                      <v-row wrap>
                        <v-col align="center" cols="12" md="12">
                          <v-data-table
                            class="modern-table"
                            disable-sort
                            disable-filtering
                            v-model="selected"
                            :loading="SearchFlag"
                            loading-text="Loading... Please wait"
                            :headers="tableColumns2"
                            :items="PenaltySubscription"
                            :items-per-page="50"
                            :search="search"
                            item-key="LomPaymentId"
                            :single-select="false"
                            :show-select="false"
                            :hide-default-footer="true"
                            :footer-props="{
                              'items-per-page-options': [10, 20, 30, 40, 50],
                            }"
                          >
                            <template v-slot:item.FineCheckBox="{ item }">
                              <v-checkbox
                                v-if="item.FineFlag"
                                v-model="item.FinePaidFlag"
                                :label="item.FineAmountTxt"
                                color="info"
                                :value="item.FinePaidFlag"
                                hide-details
                                v-on="calculatePenaltyTotal()"
                              ></v-checkbox>
                            </template>
                            <template v-slot:item.Qty="{ item }">
                              <v-text-field
                                v-model="item.Qty"
                                v-on="calculatePenaltyTotal()"
                                type="number"
                                min="0"
                                :rules="QtyRules"
                                outlined
                                dense
                                class="qty-input"
                              ></v-text-field>
                            </template>
                            <template v-slot:item.SubTotal="{ item }">
                              <div class="amount-text">
                                ₹ {{ getDecimalNumber(item.SubTotal, 2) }}
                              </div>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                      <v-row class="mt-6">
                        <v-col align="center" cols="12" md="12">
                          <h3 class="total-amount">
                            <v-icon small color="#FF6B6B" class="mr-2"
                              >mdi-calculator</v-icon
                            >
                            Total Amount :
                            <span class="amount-value"
                              >₹ {{ TotalAmount2 }}</span
                            >
                          </h3>
                          <v-checkbox
                            v-model="checkbox1"
                            :rules="checkboxRules1"
                            required
                            class="mt-4"
                          >
                            <template v-slot:label>
                              <div style="font-size: 14px">
                                I have read and accepted the
                                <a
                                  href="#"
                                  @click.prevent="openPage(6)"
                                  class="link-text"
                                  >terms and conditions</a
                                >.
                              </div>
                            </template>
                          </v-checkbox>
                          <v-btn
                            :disabled="!valid1"
                            @click.prevent="submitPenaltySubscription"
                            :loading="SubmitFlag"
                            elevation="4"
                            rounded
                            large
                            class="submit-btn btn-gradient-danger white--text"
                          >
                            <v-icon left>mdi-check-circle</v-icon>
                            Submit
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item value="tab-3">
                  <v-card flat class="tab-card" min-height="400">
                    <v-card-text
                      class="d-flex justify-center align-center flex-column py-12"
                    >
                      <v-icon size="80" color="#4ECDC4" class="mb-4"
                        >mdi-star-circle</v-icon
                      >
                      <h3 class="mb-4">Senior Members Association</h3>
                      <p class="mb-6" style="font-size: 16px; color: #666">
                        Pay subscription fees for senior member association
                        separately
                      </p>
                      <v-btn
                        href="https://seniors.jciindia.in/join-us"
                        target="_blank"
                        elevation="4"
                        rounded
                        large
                        class="submit-btn btn-gradient-primary white--text"
                      >
                        <v-icon left>mdi-open-in-new</v-icon>
                        Visit Senior Portal
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item value="tab-4" v-if="BalancePaymentFlag">
                  <v-card flat class="tab-card">
                    <v-card-text class="pt-6">
                      <v-row wrap>
                        <v-col align="center" cols="12" md="12">
                          <h3 class="tab-heading">
                            <v-icon class="mr-2" color="#FFB84D"
                              >mdi-wallet-outline</v-icon
                            >
                            List of Balance Payments
                          </h3>
                        </v-col>
                      </v-row>
                      <v-row wrap>
                        <v-col align="center" cols="12" md="12">
                          <v-data-table
                            class="modern-table"
                            disable-sort
                            disable-filtering
                            v-model="selected"
                            :loading="SearchFlag"
                            loading-text="Loading... Please wait"
                            :headers="tableColumns4"
                            :items="BalancePayment"
                            :items-per-page="50"
                            :search="search"
                            item-key="LomPaymentId"
                            :single-select="false"
                            :show-select="false"
                            :hide-default-footer="true"
                            :footer-props="{
                              'items-per-page-options': [10, 20, 30, 40, 50],
                            }"
                          >
                            <template
                              v-slot:[`item.BalanceAmountTxt`]="{ item }"
                            >
                              <div class="balance-badge">
                                {{ item.BalanceAmountTxt }}
                              </div>
                            </template>
                            <template v-slot:[`item.Qty`]="{ item }">
                              <v-text-field
                                v-model.number="item.Qty"
                                @input="calculateBalanceTotal()"
                                type="number"
                                min="0"
                                outlined
                                dense
                                class="qty-input"
                              ></v-text-field>
                            </template>
                            <template v-slot:[`item.SubTotal`]="{ item }">
                              <div class="amount-text">
                                ₹ {{ getDecimalNumber(item.SubTotal, 2) }}
                              </div>
                            </template>
                            <template v-slot:[`item.PaymentStatus`]="{ item }">
                              <v-chip
                                :color="
                                  item.BalanceAmount > 0 ? '#FFB84D' : '#4ECDC4'
                                "
                                text-color="white"
                                small
                                class="status-chip"
                              >
                                <v-icon left small>{{
                                  item.BalanceAmount > 0
                                    ? "mdi-clock-outline"
                                    : "mdi-check-circle"
                                }}</v-icon>
                                {{
                                  item.BalanceAmount > 0
                                    ? "Pending"
                                    : "Completed"
                                }}
                              </v-chip>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                      <v-row class="mt-6">
                        <v-col align="center" cols="12" md="12">
                          <h3 class="total-amount">
                            <v-icon small color="#FFB84D" class="mr-2"
                              >mdi-calculator</v-icon
                            >
                            Total Balance Amount :
                            <span class="amount-value"
                              >₹ {{ TotalAmount4 }}</span
                            >
                          </h3>
                          <h4
                            class="text-center mt-4"
                            v-if="TotalAmount4 == 0"
                            style="color: #4ecdc4; font-weight: 600"
                          >
                            <v-icon small color="#4ECDC4" class="mr-2"
                              >mdi-check-circle</v-icon
                            >
                            No balance pending for payment
                          </h4>
                          <v-checkbox
                            v-if="TotalAmount4 > 0"
                            v-model="checkbox1"
                            :rules="checkboxRules1"
                            required
                            class="mt-4"
                          >
                            <template v-slot:label>
                              <div style="font-size: 14px">
                                I have read and accepted the
                                <a
                                  href="#"
                                  @click.prevent="openPage(6)"
                                  class="link-text"
                                  >terms and conditions</a
                                >.
                              </div>
                            </template>
                          </v-checkbox>
                          <v-btn
                            :disabled="!valid1 || TotalAmount4 == 0"
                            @click.prevent="submitBalancePayment"
                            :loading="SubmitFlag"
                            elevation="4"
                            rounded
                            large
                            class="submit-btn btn-gradient-warning white--text"
                          >
                            <v-icon left>mdi-check-circle</v-icon>
                            Submit
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-form>
        </v-container>
        <br /><br />
      </v-card-text>
    </v-card>
    <v-dialog v-model="OpenPageFlag" persistent max-width="80%">
      <popup-page-content
        :addRecordPrompt="OpenPageFlag"
        :pageId="PageId"
        @hideAddRecordPrompt="hideAddRecordPrompt"
        v-if="OpenPageFlag"
      ></popup-page-content>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";

export default {
  mixins: [common],
  components: {},
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      StartupLoadingFlag: false,
      SubmitFlag: false,
      SearchFlag: false,
      NotesFlag: false,
      rows: [],
      tableColumns1: [],
      tableColumns2: [
        { text: "Date", value: "PaidDateTxt", width: "13%" },
        { text: "Description", value: "Description", width: "35%" },
        { text: "Late Fee", value: "FineAmountTxt", width: "13%" },
        { text: "To be paid", value: "FineNotPaid", width: "13%" },
        { text: "No of members", value: "Qty", width: "13%" },
        { text: "Sub Total", value: "SubTotal", width: "13%" },
      ],
      tableColumns4: [],
      selected: [],
      search: "",
      CurrentYearId: 0,

      checkbox1: false,
      checkboxRules1: [(v) => !!v || "You must agree to continue!"],

      OpenPageFlag: false,
      PageId: "",

      CheckoutTableHeaders: [],

      tab: null,
      TabDisable1: false,
      TabDisable2: false,
      TabDisable3: false,
      TabDisable4: false,

      TotalAmount: 0,
      Contribution: [],

      TotalAmount1: 0,
      TotalAmount2: 0,
      TotalAmount4: 0,

      Member: {},
      Order: {},
      MemberImageFlag: false,

      PenaltySubscription: [],
      BalancePayment: [],
      lateFeeData: [],
      seniorMembersData: [],
      balanceData: [],

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      OrderType: 1,
      MemberCityId: "",
      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      MobileNoRules: [(v) => !!v || "Mobile No is required"],

      EmailIdRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      QtyRules: [
        (v) => Number.isInteger(Number(v)) || "Nos is invalid",
        (v) => v >= 0 || "Number must be greater than zero",
      ],

      BalanceQtyRules: [],
      BalancePaymentFlag: false,
      GstNumberFlag: 2,
      GstNumberFlagRules: [
        (v) => !!v || "Does your LOM has GST number field required",
      ],
      GstNumberFlagOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "Yes" },
        { value: 2, text: "No" },
      ],

      GstNumber: "",
      GstNumberRules: [(v) => !!v || "GST number is required"],

      StateCodeRules: [(v) => !!v || "State is required"],
      StateCode: "",
      StateCodeOptions: [],
      StateCodeOptionsLoading: false,

      DistrictCodeRules: [(v) => !!v || "District is required"],
      DistrictCode: "",
      DistrictCodeOptions: [],
      DistrictCodeOptionsLoading: false,

      CityCodeRules: [(v) => !!v || "City is required"],
      CityCode: "",
      CityCodeOptions: [],
      CityCodeOptionsLoading: false,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
    };
  },
  computed: {},
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var YearName = parseInt(tr.CurrentJciYearName);
        this.YearName = YearName;

        this.JciYearCode = tr.CurrentJciYearId;
        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        this.pageData();
      }
    },
    JciYearCodeOptions: function () {
      console.log("watch JciYearCodeOptions");
      this.LoadingFlag = false;
      this.JciYearCodeOptionsLoading = false;
    },
    StateCodeOptions: function () {
      console.log("watch StateCodeOptions");
      this.StateCodeOptionsLoading = false;
    },
    StateCode: function () {
      console.log("watch StateCode");
      this.getDistrictCodeOptions(
        "DistrictCode",
        "DistrictCodeOptions",
        this.StateCode
      );
    },
    DistrictCodeOptions: function () {
      console.log("watch DistrictCodeOptions");
      this.DistrictCodeOptionsLoading = false;
    },
    DistrictCode: function () {
      console.log("watch DistrictCode");
      this.getCityCodeOptions("CityCode", "CityCodeOptions", this.DistrictCode);
    },
    CityCodeOptions: function () {
      console.log("watch CityCodeOptions");
      this.CityCodeOptionsLoading = false;
    },
    CityCode: function () {
      console.log("watch CityCode");
      console.log("CityCode" + this.CityCode);
      console.log("CityId" + this.Member.CityId);
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "lom_events",
        Action: "create",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getJciYearCodeOptions();
      this.getMemberDetails();
      // this.searchForm();
    },
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    addRecord() {
      console.log("addRecord called");
      var url = "/staff/list";
      var params = {};
      this.pageRedirect(params, url);
    },
    openPage(pageId) {
      console.log("openPage called " + pageId);
      // event.target.style.color = "salmon"
      this.PageId = pageId;
      this.OpenPageFlag = true;
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.OpenPageFlag = false;
    },
    resetForm() {
      this.$refs.form2.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    submitRegularSubscription() {
      console.log("submitRegularSubscription called");
      this.OrderType = 1;
      this.TotalAmount = this.TotalAmount1;
      this.Contribution = this.rows;
      this.confirmAlert();
    },
    submitPenaltySubscription() {
      console.log("submitPenaltySubscription called");
      this.OrderType = 2;
      this.TotalAmount = this.TotalAmount2;
      this.Contribution = this.PenaltySubscription;
      this.confirmAlert();
    },
    submitBalancePayment() {
      console.log("submitBalancePayment called");
      this.OrderType = 5;
      this.TotalAmount = this.TotalAmount4;
      this.Contribution = this.BalancePayment;
      this.confirmAlert();
    },
    calculateTotal() {
      console.log("calculateTotal called");
      var n1 = this.rows.length;
      var totalAmount = 0;
      // console.log("n1=" + n1 + ", rows=" + JSON.stringify(this.rows));
      for (var i = 0; i < n1; i++) {
        var qty = this.rows[i]["Qty"];
        var PenaltyAmount = this.rows[i]["FineAmount"];
        var WithoutFineAmount = this.rows[i]["WithoutFineAmount"];
        var FinePaidFlag = this.rows[i]["FinePaidFlag"];
        var amount = this.rows[i]["Amount"];
        console.log(
          "i=" +
            i +
            ", qty=" +
            qty +
            ", PenaltyAmount=" +
            PenaltyAmount +
            ", WithoutFineAmount=" +
            WithoutFineAmount +
            ", FinePaidFlag=" +
            FinePaidFlag +
            ", amount=" +
            amount
        );
        amount = FinePaidFlag ? amount : WithoutFineAmount;
        PenaltyAmount = FinePaidFlag ? PenaltyAmount : 0;
        console.log("amount=" + amount + ", PenaltyAmount=" + PenaltyAmount);
        qty = !isNaN(qty) ? parseInt(qty) : 0;
        amount = !isNaN(amount) ? parseFloat(amount) : 0;
        console.log("qty=" + qty + ", amount=" + amount);
        var subTotal = parseFloat(qty) * parseFloat(amount);
        this.rows[i]["Qty"] = qty;
        this.rows[i]["Amount"] = amount;
        this.rows[i]["PenaltyAmount"] = PenaltyAmount;
        this.rows[i]["PenaltyAmountTxt"] = this.getDecimalNumber(
          PenaltyAmount,
          2
        );
        this.rows[i]["SubTotal"] = isNaN(subTotal)
          ? 0
          : this.getDecimalNumber(subTotal, 2);
      }
      var totalAmount = this.rows.reduce(function (sum, line) {
        var lineTotal = parseFloat(line.SubTotal);
        console.log("lineTotal=" + lineTotal);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);
      console.log("totalAmount=" + totalAmount);
      this.TotalAmount1 = isNaN(totalAmount)
        ? 0
        : this.getDecimalNumber(totalAmount, 2);
    },
    calculatePenaltyTotal() {
      console.log("calculateTotal called");
      var rows = this.PenaltySubscription;
      var n1 = rows.length;
      var totalAmount = 0;
      // console.log("n1=" + n1 + ", rows=" + JSON.stringify(this.rows));
      for (var i = 0; i < n1; i++) {
        var qty = rows[i]["Qty"];
        var amount = rows[i]["FineAmount"];
        console.log("i=" + i + ", qty=" + qty + ", amount=" + amount);
        qty = !isNaN(qty) ? parseInt(qty) : 0;
        amount = !isNaN(amount) ? parseFloat(amount) : 0;
        console.log("qty=" + qty + ", amount=" + amount);
        var subTotal = parseFloat(qty) * parseFloat(amount);
        this.PenaltySubscription[i]["SubTotal"] = isNaN(subTotal)
          ? 0
          : this.getDecimalNumber(subTotal, 2);
        this.PenaltySubscription[i]["Amount"] = amount;
        this.PenaltySubscription[i]["Qty"] = qty;
      }
      var totalAmount = this.PenaltySubscription.reduce(function (sum, line) {
        var lineTotal = parseFloat(line.SubTotal);
        console.log("lineTotal=" + lineTotal);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);
      console.log("totalAmount=" + totalAmount);
      this.TotalAmount2 = isNaN(totalAmount)
        ? 0
        : this.getDecimalNumber(totalAmount, 2);
    },
    calculateBalanceTotal() {
      console.log("calculateBalanceTotal called");
      // SubTotal = BalanceAmount × Number of Members
      var rows = this.BalancePayment;
      var n1 = rows.length;
      for (var i = 0; i < n1; i++) {
        var balance = rows[i]["TotalBalanceAmount"];
        var qty = rows[i]["Qty"];
        balance = !isNaN(balance) ? parseFloat(balance) : 0;
        qty = !isNaN(qty) ? parseInt(qty) : 0;
        var subTotal = parseFloat(balance) * parseFloat(qty);
        this.BalancePayment[i]["SubTotal"] = isNaN(subTotal)
          ? 0
          : this.getDecimalNumber(subTotal, 2);
        this.BalancePayment[i]["Amount"] = balance;
        this.BalancePayment[i]["Qty"] = qty;
      }
      var totalAmount = this.BalancePayment.reduce(function (sum, line) {
        var lineTotal = parseFloat(line.SubTotal);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
        return sum;
      }, 0);
      this.TotalAmount4 = isNaN(totalAmount)
        ? 0
        : this.getDecimalNumber(totalAmount, 2);
    },
    getTotalBalance() {
      console.log("getTotalBalance called");
      var total = 0;
      for (var i = 0; i < this.BalancePayment.length; i++) {
        var balance = this.BalancePayment[i]["TotalBalanceAmount"];
        total += !isNaN(balance) ? balance : 0;
      }
      return this.getDecimalNumber(total, 2);
    },
    getBalanceQtyRules(balanceAmount) {
      return [
        (v) => !!v || "Amount is required",
        (v) => !isNaN(v) || "Amount must be a number",
        (v) => v > 0 || "Amount must be greater than zero",
        (v) =>
          v <= balanceAmount ||
          "Amount cannot exceed balance of ₹ " +
            this.getDecimalNumber(balanceAmount, 2),
      ];
    },
    checkout() {
      console.log("checkout");
      this.pageRedirect({}, "/members/subscription/payment/checkout");
    },
    getMemberDetails() {
      console.log("getMemberDetails is called");

      var MemberId = this.$session.get("MemberId");
      MemberId = MemberId == (null || undefined) ? "" : MemberId;

      console.log("MemberId=" + MemberId);

      if (MemberId != "") {
        this.SubmitFlag = true;
        this.StartupLoadingFlag = true;
        this.Member = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/show";
        var upload = {
          UserInterface: 1,
          MemberId: MemberId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SubmitFlag = false;
            thisIns.StartupLoadingFlag = false;
            thisIns.BalancePaymentFlag = false;
            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              var member = records[0];
              thisIns.Member = member;
              thisIns.MemberImageFlag = true;
              thisIns.Member.EmailId =
                member.EmailId == "NA" ? "" : member.EmailId;
              thisIns.Member.PrimaryMobile =
                member.PrimaryMobile == "NA" ? "" : member.PrimaryMobile;
              // thisIns.MemberCityId = member.CityId;
              thisIns.getStateCodeOptions("StateCode", "StateCodeOptions");
              thisIns.StateCode = member.LomStateId;
              thisIns.DistrictCode = member.LomDistrictId;
              thisIns.CityCode = member.LomCityId;
              thisIns.BalancePaymentFlag = member.BalancePaymentFlag;
              // thisIns.toast("success", output);
              // thisIns.resetForm();
              thisIns.searchForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            this.StartupLoadingFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        this.toast("error", message);
      }
    },
    getStateCodeOptions(source, destination) {
      console.log("getStateCodeOptions called");
      if (source != "" && destination != "") {
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/states/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getDistrictCodeOptions(source, destination, StateCode) {
      console.log("getDistrictCodeOptions called StateCode=" + StateCode);
      if (source != "" && destination != "" && StateCode != "") {
        this.DistrictCodeOptionsLoading = true;
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/district/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          StatesCode: StateCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getCityCodeOptions(source, destination, DistrictCode) {
      console.log("getCityCodeOptions called DistrictCode=" + DistrictCode);
      if (source != "" && destination != "" && DistrictCode != "") {
        this.CityCodeOptionsLoading = true;
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/city/options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          DistrictCode: DistrictCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getJciYearCodeOptions() {
      this.LoadingFlag = true;
      this.JciYearCodeOptionsLoading = true;
      console.log("getJciYearCodeOptions called");
      var selectbox1_source = "JciYearCode";
      var selectbox1_destination = "JciYearCodeOptions";
      var selectbox1_url = "api/jci-year/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    searchForm() {
      console.log("searchForm is called");
      this.getRegularSubscriptionList();
      this.getPenaltySubscriptionList();
      this.getBalanceAmountSubscriptionList();
    },
    getRegularSubscriptionList() {
      console.log("getRegularSubscriptionList is called");

      var JciYearCode = this.JciYearCode;
      console.log("JciYearCode=" + JciYearCode);

      // JciYearCode = "";

      if (JciYearCode != "") {
        this.SearchFlag = true;
        this.rows = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/year-wise-contribution/lists";
        var upload = {
          UserInterface: 1,
          YearCode: JciYearCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.rows = records.TableData;
              thisIns.calculateTotal();
              // thisIns.toast("success", output);
              // thisIns.resetForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            this.SearchFlag = false;
          });
      } else {
        var message = "";
        if (JciYearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getPenaltySubscriptionList() {
      console.log("getPenaltySubscriptionList is called");

      var LomId = this.Member.LomId;
      console.log("LomId=" + LomId);

      // LomId = "";

      if (LomId != "") {
        this.SearchFlag = true;
        this.PenaltySubscription = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-payment/lists";
        var upload = {
          UserInterface: 2,
          LomCode: LomId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              // thisIns.tableColumns1 = records.TableHeader;
              thisIns.PenaltySubscription = records;
              thisIns.calculatePenaltyTotal();
              // thisIns.toast("success", output);
              // thisIns.resetForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            this.SearchFlag = false;
          });
      } else {
        var message = "";
        if (LomId == "") {
          message += "Lom should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getBalanceAmountSubscriptionList() {
      console.log("getBalanceAmountSubscriptionList is called");

      var LomId = this.Member.LomId;
      console.log("LomId=" + LomId);

      // LomId = "";

      if (LomId != "") {
        this.SearchFlag = true;
        this.BalancePayment = [];
        this.tableColumns4 = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-payment/lists";
        var upload = {
          UserInterface: 4,
          LomCode: LomId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = false;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            var TableContent = response.data.table_content;
            console.log({ TableContent });

            if (flag) {
              // thisIns.tableColumns1 = records.TableHeader;
              thisIns.BalancePayment = records;
              thisIns.tableColumns4 = TableContent.TableHeader;
              thisIns.calculateBalanceTotal();
              // thisIns.toast("success", output);
              // thisIns.resetForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            this.SearchFlag = false;
          });
      } else {
        var message = "";
        if (LomId == "") {
          message += "Lom should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    confirmAlert() {
      var validate1 = this.$refs.form2.validate();
      var TotalAmount = this.TotalAmount;
      console.log("validate1=" + validate1 + ", TotalAmount=" + TotalAmount);

      // TotalAmount=0;

      if (validate1 && TotalAmount > 0) {
        Swal.fire({
          title: "Do you want to continue?",
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (TotalAmount == 0) {
          message += "Minimum one nos required to continue. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form2.validate();
      var TotalAmount = this.TotalAmount;
      console.log("validate1=" + validate1 + ", TotalAmount=" + TotalAmount);

      // TotalAmount=0;

      if (validate1 && TotalAmount > 0) {
        this.SubmitFlag = true;
        this.TabDisable1 = true;
        this.TabDisable2 = true;

        // Get Year name from JciYearCodeOptions

        var JciYearCode = this.JciYearCode;
        var JciYearCodeIndex = this.JciYearCodeOptions.map(
          (e) => e.value
        ).indexOf(JciYearCode);
        console.log(
          "JciYearCode=" +
            JciYearCode +
            ", JciYearCodeIndex=" +
            JciYearCodeIndex
        );
        var JciYearName = this.JciYearCodeOptions[JciYearCodeIndex].text;
        console.log("JciYearName=" + JciYearName);

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/subscription/orders/create";
        var upload = {
          YearCode: this.JciYearCode,
          OrderType: this.OrderType,
          YearName: JciYearName,
          GstNumberFlag: this.GstNumberFlag,
          GstNumber: this.Member.LomGstNumber,
          LoState: this.StateCode,
          LoDistrict: this.DistrictCode,
          LoCity: this.CityCode,
          Member: this.Member,
          Contribution: this.Contribution,
          TotalAmount: this.TotalAmount,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        // this.$session.set("checkout", upload);
        // this.checkout();

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SubmitFlag = false;
            thisIns.TabDisable1 = false;
            thisIns.TabDisable2 = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              upload["PaymentGateway"] = records.payment_gateway;
              upload["Order"] = records.order_config;
              upload["Theme"] = records.theme_config;
              // upload["Contribution"] = records.contribution;
              upload["TableHeaders"] = records.CheckoutTableHeaders;
              upload["Contribution"] = records.contribution;
              console.log("checkout upload=" + JSON.stringify(upload));
              console.log("tableHeaders=" + upload["TableHeaders"]);
              thisIns.$session.set("checkout", upload);
              thisIns.sweetAlert(
                "info",
                "You will be redirected to checkout page shortly",
                true
              );
              thisIns.checkout();
            } else {
              // thisIns.toast("error", output);
              thisIns.sweetAlert("info", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.TabDisable1 = false;
            thisIns.TabDisable2 = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (TotalAmount == 0) {
          message += "Minimum one nos required to continue. ";
        }
        this.sweetAlert("error", message, false);
        // this.toast("error", message);
      }
    },
  },
  beforeMount() {
    var CurrentYearId = this.$session.get("CurrentYearId");
    CurrentYearId = 1;
    CurrentYearId = CurrentYearId == (null || undefined) ? 0 : CurrentYearId;
    this.CurrentYearId = CurrentYearId;
    if (this.$session.has("checkout")) {
      this.$session.remove("checkout");
    }
    this.refreshPageData();
    /*
    this.tableColumns1.push(
      { text: "Description", value: "Description" },
      { text: "Subscription Fees", value: "AmountTxt" },
      { text: "Nos", value: "Qty" },
      { text: "Sub Total", value: "SubTotal" }
      // { text: "Actions", value: "actions" }
    );
    */
  },
};
</script>
<style lang="scss">
#member-subscription-create {
  font-family: "Poppins", sans-serif;
  background-color: #f4f7fa; // Subtle background for contrast

  // --- Animations ---
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(40px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes pulse-glow {
    0% {
      box-shadow: 0 0 0 0 rgba(137, 80, 252, 0.4);
    }

    70% {
      box-shadow: 0 0 0 15px rgba(137, 80, 252, 0);
    }

    100% {
      box-shadow: 0 0 0 0 rgba(137, 80, 252, 0);
    }
  }

  @keyframes float {
    0% {
      transform: translateY(0px);
    }

    50% {
      transform: translateY(-10px);
    }

    100% {
      transform: translateY(0px);
    }
  }

  @keyframes shimmer {
    0% {
      background-position: -200% center;
    }

    100% {
      background-position: 200% center;
    }
  }

  @keyframes fly {
    0% {
      transform: translateY(0) translateX(0);
    }

    50% {
      transform: translateY(-5px) translateX(5px);
    }

    100% {
      transform: translateY(0) translateX(0);
    }
  }

  .slide-up-animation {
    animation: slideUp 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
    opacity: 0;
  }

  .delay-100 {
    animation-delay: 0.1s;
  }

  .delay-200 {
    animation-delay: 0.2s;
  }

  .delay-300 {
    animation-delay: 0.3s;
  }

  .float-animation {
    animation: float 6s ease-in-out infinite;
  }

  // --- Header Styles ---
  .modern-header {
    border-radius: 20px;
    margin-bottom: 30px;
    overflow: hidden;
    background: white;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    border: 1px solid rgba(255, 255, 255, 0.8);

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08) !important;
    }
  }

  .modern-card-title {
    padding: 32px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // JCI Navy gradient
    background: linear-gradient(135deg, #3a67b1 0%, #2a5299 100%);
    position: relative;
    overflow: hidden;

    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.1) 0%,
        rgba(255, 255, 255, 0) 100%
      );
      pointer-events: none;
      z-index: 1;
    }
  }

  .bubbles-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 0;
    perspective: 1000px;
  }

  // --- Floating Bubbles Animation ---
  .bg-bubbles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    margin: 0;
    padding: 0;
  }

  .bg-bubbles li {
    position: absolute;
    list-style: none;
    display: block;
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.2);
    bottom: -160px;
    animation: square 25s infinite;
    transition-timing-function: linear;
    border-radius: 50%;
  }

  .bg-bubbles li:nth-child(1) {
    left: 10%;
  }

  .bg-bubbles li:nth-child(2) {
    left: 20%;
    width: 80px;
    height: 80px;
    animation-delay: 2s;
    animation-duration: 17s;
  }

  .bg-bubbles li:nth-child(3) {
    left: 25%;
    animation-delay: 4s;
  }

  .bg-bubbles li:nth-child(4) {
    left: 40%;
    width: 60px;
    height: 60px;
    animation-duration: 22s;
    background-color: rgba(255, 255, 255, 0.25);
  }

  .bg-bubbles li:nth-child(5) {
    left: 70%;
  }

  .bg-bubbles li:nth-child(6) {
    left: 80%;
    width: 120px;
    height: 120px;
    animation-delay: 3s;
    background-color: rgba(255, 255, 255, 0.2);
  }

  .bg-bubbles li:nth-child(7) {
    left: 32%;
    width: 160px;
    height: 160px;
    animation-delay: 7s;
  }

  .bg-bubbles li:nth-child(8) {
    left: 55%;
    width: 20px;
    height: 20px;
    animation-delay: 15s;
    animation-duration: 40s;
  }

  .bg-bubbles li:nth-child(9) {
    left: 25%;
    width: 10px;
    height: 10px;
    animation-delay: 2s;
    animation-duration: 40s;
    background-color: rgba(255, 255, 255, 0.3);
  }

  .bg-bubbles li:nth-child(10) {
    left: 90%;
    width: 160px;
    height: 160px;
    animation-delay: 11s;
  }

  @keyframes square {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-700px) rotate(600deg);
    }
  }

  .header-left {
    display: flex;
    align-items: center;
    z-index: 2;
    position: relative;
  }

  .flying-icon {
    animation: fly 3s ease-in-out infinite;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  }

  .page-title {
    font-size: 28px;
    font-weight: 800;
    color: #ffffff;
    margin: 0;
    line-height: 1.2;
    letter-spacing: -0.5px;
    text-shadow: 0 4px 10px rgba(255, 255, 255, 0.3);

    // Shimmer effect on text
    background: linear-gradient(
      to right,
      #fff 0%,
      #e0e0e0 20%,
      #fff 40%,
      #fff 100%
    );
    background-size: 200% auto;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: shimmer 5s linear infinite;
  }

  .page-subtitle {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.85);
    margin-top: 4px;
    font-weight: 500;
    letter-spacing: 0.5px;
  }

  .action-btn {
    transition: all 0.3s ease;
    border-radius: 14px;
    background-color: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.2);

    &:hover {
      transform: translateY(-3px) scale(1.05);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
      background-color: rgba(255, 255, 255, 0.25);
    }
  }

  // --- Form Sections (Professional with Header Colors) ---
  .form-section {
    border-radius: 16px;
    border: 1px solid rgba(58, 103, 177, 0.2);
    background: linear-gradient(to bottom right, #ffffff, #f8faff);
    box-shadow: 0 8px 24px rgba(58, 103, 177, 0.08);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    margin-bottom: 28px;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 5px;
      height: 100%;
      background: linear-gradient(to bottom, #3a67b1, #0097d7);
    }

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 16px 40px rgba(58, 103, 177, 0.12);
      border-color: rgba(0, 151, 215, 0.35);
    }
  }

  .form-section-org,
  .form-section-location {
    animation: cardFloatIn 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
  }

  @keyframes cardFloatIn {
    0% {
      opacity: 0;
      transform: translateY(30px) scale(0.95);
    }

    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  // --- Card Bubbles Animation ---
  .card-bubbles-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 0;
    opacity: 0.3;
  }

  .card-bubble {
    position: absolute;
    background: radial-gradient(
      circle at 30% 30%,
      rgba(58, 103, 177, 0.4),
      rgba(58, 103, 177, 0.1)
    );
    border-radius: 50%;
    animation: card-bubble-float 8s infinite ease-in-out;
  }

  .card-bubble:nth-child(1) {
    width: 80px;
    height: 80px;
    top: 10%;
    left: 5%;
    animation-duration: 8s;
    animation-delay: 0s;
  }

  .card-bubble:nth-child(2) {
    width: 50px;
    height: 50px;
    top: 20%;
    right: 10%;
    animation-duration: 10s;
    animation-delay: 1s;
  }

  .card-bubble:nth-child(3) {
    width: 60px;
    height: 60px;
    bottom: 15%;
    left: 8%;
    animation-duration: 9s;
    animation-delay: 2s;
  }

  .card-bubble:nth-child(4) {
    width: 45px;
    height: 45px;
    bottom: 10%;
    right: 5%;
    animation-duration: 7s;
    animation-delay: 1.5s;
  }

  .card-bubble:nth-child(5) {
    width: 55px;
    height: 55px;
    top: 50%;
    right: 15%;
    animation-duration: 11s;
    animation-delay: 0.5s;
  }

  .card-bubble:nth-child(6) {
    width: 40px;
    height: 40px;
    top: 30%;
    left: 20%;
    animation-duration: 8.5s;
    animation-delay: 2.5s;
  }

  @keyframes card-bubble-float {
    0% {
      transform: translateY(0) translateX(0) scale(1);
      opacity: 0.3;
    }

    25% {
      transform: translateY(-20px) translateX(15px) scale(1.1);
      opacity: 0.5;
    }

    50% {
      transform: translateY(-40px) translateX(-10px) scale(0.9);
      opacity: 0.3;
    }

    75% {
      transform: translateY(-15px) translateX(20px) scale(1.05);
      opacity: 0.4;
    }

    100% {
      transform: translateY(0) translateX(0) scale(1);
      opacity: 0.3;
    }
  }

  .card-bubbles-tabs {
    background: linear-gradient(
      135deg,
      rgba(58, 103, 177, 0.08),
      rgba(0, 151, 215, 0.04)
    );
  }

  .section-title {
    font-size: 18px;
    font-weight: 800;
    color: #3a67b1;
    background: linear-gradient(
      to right,
      rgba(58, 103, 177, 0.05),
      rgba(0, 151, 215, 0.02)
    );
    padding: 22px 28px;
    border-bottom: 2px solid rgba(48, 43, 99, 0.12);
    display: flex;
    align-items: center;
    gap: 14px;
    letter-spacing: 0.3px;
    position: relative;
    z-index: 2;

    .section-icon-wrapper {
      background: linear-gradient(
        135deg,
        rgba(58, 103, 177, 0.15),
        rgba(0, 151, 215, 0.08)
      );
      padding: 10px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 40px;
      min-height: 40px;
      box-shadow: 0 4px 12px rgba(48, 43, 99, 0.1);
      transition: all 0.3s ease;
    }

    .v-icon {
      font-size: 22px !important;
    }

    &:hover .section-icon-wrapper {
      transform: scale(1.1) rotate(5deg);
      box-shadow: 0 6px 16px rgba(48, 43, 99, 0.15);
    }
  }

  // --- Inputs ---
  .v-input__slot {
    border-radius: 10px !important;
    transition: all 0.3s ease;

    &:hover {
      background-color: rgba(58, 103, 177, 0.02) !important;
    }
  }

  .v-text-field--outlined.v-input--is-focused fieldset {
    border: 2px solid #0097d7 !important;
    box-shadow: 0 0 0 4px rgba(0, 151, 215, 0.08);
  }

  .v-text-field--outlined fieldset {
    border-color: rgba(58, 103, 177, 0.2) !important;
  }

  .field-label {
    font-size: 12px;
    font-weight: 700;
    color: #3a67b1;
    margin-bottom: 10px;
    display: block;
    text-transform: uppercase;
    letter-spacing: 0.9px;
  }

  .info-text {
    font-size: 17px;
    font-weight: 800;
    color: #0a0f29;
    margin: 0 0 4px 0;
    letter-spacing: -0.3px;
  }

  .info-subtext {
    font-size: 13px;
    color: #414042;
    margin: 0;
    font-weight: 600;
    letter-spacing: 0.2px;
  }

  .member-image {
    border-radius: 50%;
    border: 6px solid #fff;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    transition: transform 0.4s ease;

    &:hover {
      transform: scale(1.1) rotate(5deg);
    }
  }

  // --- Tabs ---
  .modern-tabs {
    border-radius: 20px 20px 0 0;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
  }

  .custom-tabs-bg {
    // JCI Navy gradient
    background: linear-gradient(135deg, #3a67b1 0%, #2a5299 100%) !important;
  }

  .v-tab {
    font-weight: 700;
    letter-spacing: 1px;
    font-size: 14px;
    padding: 16px 24px;
    opacity: 0.7;
    transition: all 0.3s;

    &.v-tab--active {
      opacity: 1;
      background: rgba(237, 190, 56, 0.2);
      backdrop-filter: blur(5px);
      color: #ffffff !important;
    }

    &:hover {
      opacity: 1;
      background: rgba(255, 255, 255, 0.05);
    }
  }

  .tab-card {
    border-radius: 0 0 16px 16px;
    border: 1px solid rgba(58, 103, 177, 0.15);
    border-top: none;
    background: linear-gradient(to bottom right, #ffffff, #f5f8ff);
    box-shadow: 0 12px 28px rgba(58, 103, 177, 0.06);
    position: relative;
    z-index: 2;
    animation: tabCardSlideIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  @keyframes tabCardSlideIn {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .tab-heading {
    font-size: 20px;
    font-weight: 700;
    color: #3a67b1;
    margin-bottom: 28px;
    padding: 16px 32px;
    background: linear-gradient(
      to right,
      rgba(58, 103, 177, 0.08),
      rgba(0, 151, 215, 0.03)
    );
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    border: 1px solid rgba(58, 103, 177, 0.12);
    box-shadow: 0 4px 12px rgba(58, 103, 177, 0.04);

    .v-icon {
      color: #3a67b1 !important;
    }
  }

  // --- Table ---
  .modern-table {
    border: 1px solid rgba(58, 103, 177, 0.15) !important;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 8px 20px rgba(58, 103, 177, 0.06) !important;

    thead {
      background: linear-gradient(
        to right,
        rgba(58, 103, 177, 0.08),
        rgba(0, 151, 215, 0.04)
      );

      th {
        font-weight: 800 !important;
        color: #3a67b1 !important;
        text-transform: uppercase;
        font-size: 12px !important;
        letter-spacing: 1.1px;
        height: 65px !important;
        border-bottom: 2px solid rgba(48, 43, 99, 0.2) !important;
        padding: 14px 16px !important;
      }
    }

    tbody {
      tr {
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        border-bottom: 1px solid rgba(58, 103, 177, 0.08) !important;

        &:hover {
          background-color: rgba(58, 103, 177, 0.04) !important;
          box-shadow: 0 4px 12px rgba(58, 103, 177, 0.08) inset;
        }

        &:last-child {
          border-bottom: none !important;
        }
      }

      td {
        font-size: 14px !important;
        color: #414042;
        height: 68px !important;
        padding: 14px 16px !important;
        font-weight: 500;
      }
    }
  }

  .qty-input {
    max-width: 100px;
    margin: 0 auto;

    input {
      text-align: center;
      font-weight: 700;
      font-size: 16px;
      color: #2d3748;
    }
  }

  .amount-text {
    font-weight: 800;
    color: #0a0f29;
    font-family: "IBM Plex Mono", "Roboto Mono", monospace;
    font-size: 15px;
    background: rgba(58, 103, 177, 0.05);
    padding: 6px 10px;
    border-radius: 6px;
    letter-spacing: 0.3px;
  }

  // --- Total & Submit ---
  .total-amount {
    font-size: 20px;
    font-weight: 700;
    color: #0a0f29;
    padding: 26px 42px;
    background: linear-gradient(
      to right,
      rgba(58, 103, 177, 0.06),
      rgba(237, 190, 56, 0.02)
    );
    border: 2px solid rgba(58, 103, 177, 0.15);
    border-radius: 14px;
    display: inline-flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 8px 20px rgba(58, 103, 177, 0.06);

    .v-icon {
      color: #3a67b1;
    }

    .amount-value {
      font-size: 34px;
      font-weight: 900;
      background: linear-gradient(135deg, #3a67b1 0%, #0097d7 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "IBM Plex Mono", "Roboto Mono", monospace;
      letter-spacing: 1px;
    }
  }

  .submit-btn {
    font-weight: 800;
    letter-spacing: 1px;
    text-transform: uppercase;
    min-width: 280px;
    height: 56px !important;
    border-radius: 12px;
    background: linear-gradient(135deg, #56bda3 0%, #0097d7 100%) !important;
    box-shadow: 0 8px 20px rgba(58, 103, 177, 0.25);
    color: #ffffff !important;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    animation: pulse-glow-header 3s infinite;

    &:hover {
      transform: translateY(-4px) scale(1.02);
      box-shadow: 0 16px 36px rgba(58, 103, 177, 0.35);
    }

    &:disabled {
      box-shadow: none;
      animation: none;
      opacity: 0.7;
      background: #cbd5e0 !important;
      color: #718096 !important;
    }
  }

  @keyframes pulse-glow-header {
    0% {
      box-shadow: 0 8px 20px rgba(58, 103, 177, 0.25);
    }

    70% {
      box-shadow: 0 8px 20px rgba(58, 103, 177, 0.4);
    }

    100% {
      box-shadow: 0 8px 20px rgba(58, 103, 177, 0.25);
    }
  }

  .btn-gradient-success {
    background: linear-gradient(135deg, #00b09b 0%, #016e62 100%) !important;
  }

  .btn-gradient-danger {
    background: linear-gradient(135deg, #ff6b6b 0%, #fd3838 100%) !important;
  }

  .btn-gradient-warning {
    background: linear-gradient(135deg, #1f1403 0%, #ffa500 100%) !important;
  }

  .btn-gradient-primary {
    background: linear-gradient(135deg, #8fe0cc 0%, #0099ff 100%) !important;
  }

  // --- Badges ---
  .balance-badge {
    background: #fff3e0;
    color: #f57c00;
    padding: 8px 16px;
    border-radius: 30px;
    font-weight: 800;
    font-size: 14px;
    display: inline-block;
    border: 1px solid #ffe0b2;
    box-shadow: 0 4px 10px rgba(245, 124, 0, 0.15);
  }

  .status-chip {
    font-weight: 700;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }

  .link-text {
    color: #302b63;
    font-weight: 700;
    text-decoration: none;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 2px;
      bottom: -2px;
      left: 0;
      background-color: #302b63;
      transform: scaleX(0);
      transition: transform 0.3s ease;
    }

    &:hover::after {
      transform: scaleX(1);
    }
  }

  // --- Notes ---
  .modern-notes {
    background: linear-gradient(
      to right,
      rgba(195, 20, 50, 0.05),
      rgba(195, 20, 50, 0.02)
    );
    backdrop-filter: blur(5px);
    border: 1px solid rgba(195, 20, 50, 0.2);
    border-left: 5px solid #c31432;
    border-radius: 12px;
    padding: 24px 28px;
    margin-bottom: 28px;
    box-shadow: 0 4px 16px rgba(195, 20, 50, 0.08);

    .notes-title {
      font-weight: 800;
      color: #c31432;
      font-size: 15px;
      margin-bottom: 14px;
      display: inline-block;
      text-transform: uppercase;
      letter-spacing: 0.6px;
    }

    .v-icon {
      color: #c31432 !important;
    }

    .notes-list li .v-icon {
      color: #302b63 !important;
    }
  }

  // --- Required Field Indicator ---
  .required-pill {
    display: inline-flex;
    align-items: center;
    background: linear-gradient(
      to right,
      rgba(48, 43, 99, 0.06),
      rgba(48, 43, 99, 0.02)
    );
    padding: 10px 26px;
    border-radius: 50px;
    box-shadow: 0 4px 12px rgba(15, 12, 41, 0.08);
    border: 1px solid rgba(48, 43, 99, 0.2);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 18px rgba(15, 12, 41, 0.12);
      border-color: rgba(48, 43, 99, 0.35);
      background: linear-gradient(
        to right,
        rgba(48, 43, 99, 0.08),
        rgba(48, 43, 99, 0.04)
      );
    }

    .required-star {
      color: #c31432;
      font-size: 24px;
      line-height: 0;
      margin-right: 8px;
      margin-top: 6px;
      font-weight: bold;
      animation: pulse-red 2s infinite;
    }

    .required-text {
      font-size: 11px;
      font-weight: 700;
      color: #302b63;
      letter-spacing: 0.6px;
      text-transform: uppercase;
    }
  }

  @keyframes pulse-red {
    0% {
      transform: scale(1);
      opacity: 1;
    }

    50% {
      transform: scale(1.2);
      opacity: 0.8;
    }

    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  /* Tab Indicator Styles */
  @keyframes tab-blink {
    0%,
    49% {
      opacity: 1;
      box-shadow: 0 0 0 3px rgba(237, 190, 56, 0.6);
    }
    50%,
    100% {
      opacity: 0.3;
      box-shadow: 0 0 0 3px rgba(237, 190, 56, 0.3);
    }
  }

  .tab-has-records {
    position: relative;

    &::after {
      content: "●";
      position: absolute;
      right: 8px;
      top: 4px;
      font-size: 10px;
      color: #edbe38;
      animation: tab-blink 1.5s infinite;
      font-weight: bold;
    }
  }
}
</style>